import styled from "styled-components";

export const DrawerContainer = styled.div`
  .ms-Panel-main {
    width: ${(props: { size?: string }) => props.size || "320px"};
    max-width: 100%;
    overflow: auto;
  }
`;
